import { IOrderDetails } from '@/interfaces/api/orders/IOrder';
import { IProduct, IProductVariant } from '@/interfaces/api/product/IProduct';

export const orderDetailsMapper = (
	productId: string,
	variantId: string,
	isCSVHaggle: boolean,
	product: IProduct | null,
	variant: IProductVariant | null,
	originalPrice: number,
	finalPrice: number,
	discountAmount: number,
	quantity: number,
	subtotal: number,
) => {
	const orderDetails: IOrderDetails = {
		product: {
			id: productId,
			isCSVHaggle: isCSVHaggle,
			title: product?.title ?? null,
			handle: product?.handle ?? null,
			tags: product?.tags ?? null,
			imageSrc: product?.images?.[0]?.src ?? null,
		},
		variant: {
			id: variantId,
			isCSVHaggle: isCSVHaggle,
			type: variant?.type ?? null,
			title: variant?.title ?? null,
			sku: variant?.sku ?? null,
		},
		pricing: {
			originalPrice: originalPrice,
			finalPrice: finalPrice,
			discountAmount: discountAmount,
			quantity: quantity,
			subtotal: subtotal,
			total: subtotal,
		},
	};
	return orderDetails;
};
